"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var widgets_1 = require("@tableau/widgets");
var typestyle_1 = require("typestyle");
var buttonSpan = {
    display: 'inline-flex',
    alignItems: 'center',
    verticalAlign: 'middle',
};
exports.buttonSpan = buttonSpan;
var container = {
    display: 'flex',
    marginTop: widgets_1.TabStyles.Spacing.LargeSpace,
};
exports.container = container;
var input = {
    width: '100%',
};
exports.input = input;
var inputContainer = {
    flexGrow: 1,
};
exports.inputContainer = inputContainer;
var button = {
    marginLeft: '-1px',
    alignSelf: 'flex-end',
    borderRadius: '1px',
};
exports.button = button;
var primaryButtonClassName = typestyle_1.style({
    $nest: {
        '&:not(:focus)': {
            borderColor: widgets_1.TabStyles.Colors.L6,
        },
        '&:focus': {
            'zIndex': 1,
        }
    }
});
exports.primaryButtonClassName = primaryButtonClassName;
var icon = {
    marginRight: '8px',
};
exports.icon = icon;
var label = {
    display: 'block',
    color: '#4F4F4F',
    marginBottom: '4px',
    fontSize: widgets_1.TabStyles.Typography.Sizing.Default,
};
exports.label = label;
//# sourceMappingURL=ShareLinkStyle.js.map